const evaluateCount = ({
  categoryMax,
  categoryAutoBalance,
  categoryTotal,
  count,
  isAvailable,
} = {}) => {
  const { updatedByHandler = false, current } = count || {};

  if (categoryAutoBalance) {
    const balanceAmountDiff = categoryMax - categoryTotal;
    const evaluatedCurrentCount = updatedByHandler ? current : current + balanceAmountDiff;

    return {
      ...count,
      current: evaluatedCurrentCount,
      updatedByHandler: false,
    };
  }

  let countCpy = { ...count };

  /**
   * Setting default current count to 0 for unavailable default items
   * @see https://fingermarkglobal.atlassian.net/browse/S2OP-2085
   */
  if (!isAvailable && current && typeof countCpy === 'object' && 'current' in countCpy) {
    countCpy.current = 0;
  }

  return {
    ...countCpy,
    updatedByHandler: false,
  };
};

export { evaluateCount };
